import { DeliveryorderEdit, ExportDeliveryorder,DeliverydetailsAdd,RepairdetailsAdd,DeliverydetailsEdit,DeliveryCombine,ExportDeliveryStatistics,
    UploadDeliveryattachment,DeliveryattachmentDel,DeliverydetailsDel,RepairdetailsDel,DeliverystatisticsEdit,CostrecordAdd,CostrecordDel,CostrecordDiamondAdd,CostEdit } from "@a/deliveryorder.js";
import Cookies from "js-cookie"
//cookies
import { setToken, setUsername, getUsername, getToken, removeToken, removeUsername } from "../../utils/cookies";
const state ={
    token: "" || getToken(),
    username: "" || getUsername(),
}
const getters ={}
const mutations ={
    SET_TOKEN(state, value){ // 设置 token
        state.token = value;
        value && setToken(value);
    },
    SET_USERNAME(state, value){ // 设置用户名
        state.username = value;
        value && setUsername(value);
    },
}
const actions ={
    editAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            DeliveryorderEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    addDeliverydetailsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            DeliverydetailsAdd(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    editDeliverydetailsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            DeliverydetailsEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    addRepairdetailsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            RepairdetailsAdd(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    exportAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            ExportDeliveryorder(repuestData).then((response) => {
                // 获取头文件中的内容为了读取后端发送文件的文件名
        var disposition = response.headers['content-disposition']
        var fileName = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))
        // 创建blob流并将数据添加进去，根据不同类型文件设置不同的type，excel就设置这种type就可以了
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }) // 假设文件为pdf
        // 创建组件并点击，地址为流地址，之后销毁掉
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
            }).catch(error => {
                reject(error);
            })
        })
    },
    deleteDeliveryattachmentAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            DeliveryattachmentDel(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    uploadAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            UploadDeliveryattachment(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    deleteDeliverydetailsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            DeliverydetailsDel(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    editDeliverystatisticsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            DeliverystatisticsEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    combineDeliveryAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            DeliveryCombine(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    exportStatisticsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            ExportDeliveryStatistics(repuestData).then((response) => {
                // 获取头文件中的内容为了读取后端发送文件的文件名
        var disposition = response.headers['content-disposition']
        var fileName = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))
        // 创建blob流并将数据添加进去，根据不同类型文件设置不同的type，excel就设置这种type就可以了
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }) // 假设文件为pdf
        // 创建组件并点击，地址为流地址，之后销毁掉
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
            }).catch(error => {
                reject(error);
            })
        })
    },
    deleteRepairdetailsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            RepairdetailsDel(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },

 costrecordaddAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            CostrecordAdd(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
 costrecordDiamondaddAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            CostrecordDiamondAdd(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
deleteCostrecordAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            CostrecordDel(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    editCostAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            CostEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};